<template>
  <div>
    <order-part-fee-view v-if="isView" :form-data="formData" @to-edit="isView=false"/>
    <order-part-fee-fill v-else :form-data="formData" :options-pay-methods="optionsPayMethods"/>
  </div>
</template>
<script>

import OrderPartFeeFill from "@/views/adOrder/order/components/fee/components/fill.vue";
import OrderPartFeeView from "@/views/adOrder/order/components/fee/components/view.vue";

export default {
  name: "OrderPartFee",
  components: {OrderPartFeeView, OrderPartFeeFill},
  props: {
    optionsPayMethods: Array,
    formData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.$route.name === 'createAdOrder') {
      this.isView = false;
    }
  },
  data() {
    return {
      isView: true,
    }
  }
}
</script>
<style lang="scss">
.fee-tip {
  width: 100%;
  padding: 18px;
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(255, 208, 214, 0.15), rgba(255, 208, 214, 0.35) 80%, rgb(253, 241, 242) 179%);
  font-family: FjallaOne-Regular, sans-serif !important;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;

  .fee-tip__item.one-row {
    grid-column: span 2;
  }

  .fee-tip__item {
    padding: 8px;
    border-radius: 12px;
    border: 1.5px solid #fff;
    background: linear-gradient(45deg, hsla(0,0%,100%,.6) -17%, hsla(0, 0%, 100%, .7) 31%, hsla(0, 0%, 100%, .14) 95%);
    display: flex;

    .fee-tip__item-symbol {
      margin: 0 6px;
    }

    .fee-tip__item-field div:last-child {
      color: #8a8e99;
    }
  }
}
</style>
